const common = {
  currency: 'Kr.',
  currencySymbol: 'Kr.',
  percentSymbol: '%',
  logout: 'Logga ut',
  or: 'Eller',
  days: 'dagar',
  minutes: 'minuter',
  goBack: 'Tillbaka',
};

const contact = {
  email: 'support@vivus.se',
  phone: '08-420 400 20',
  businessHours: 'Måndag – Fredag: </br>08:00-17:00',
  termsAndConditionsText: 'TRANSLATE: Términos y condiciones',
};

const translations = {
  common: {
    ...common,
    ...contact,
  },
  calculator: {
    title: 'Redigera lånebelopp',
    amountTitle: '',
    amountUnit: common.currencySymbol,
    daysTitle: '',
    daysUnit: '',
    confirmChanges: 'bekräfta',
    openLoanInformationModal: '',
    titleModal: '',
  },
  sessionExpired: {
    title: 'Din session har gått ut',
    text: 'Oroa dig inte, vi höll alla dina inmatade uppgifter på plats. Du behöver bara klicka på "Gå till inloggningssida" och använda dina referenser för att logga in och fortsätta processen från den plats du lämnade.',
    goToLogin: 'Gå till inloggningssida',
  },
  passwordRecovery: {
    title: 'Glömt lösenordet?',
    emailTitle: 'Skriv in din e-postadress',
    email: 'E-post',
    continue: 'Fortsätta',
  },
  temporaryPasswordSent: {
    title: 'Tillfälligt Lösenord skickas till din e-post',
    text: 'Vi har skickat ett tillfälligt lösenord till din e-post, som du nu kan använda för att logga in.',
    login: 'logga in',
  },
  login: {
    title: 'Logga in på ditt konto',
    email: 'E-post',
    password: 'Lösenord',
    login: 'logga in',
    forgotPassword: 'Kommer du inte ihåg ditt lösenord?',
  },
  createNewPassword: {
    title: 'Skapa ett nytt lösenord',
    newPassword: 'Nytt lösenord',
    reenterNewPassword: 'Ange nytt lösenord',
    save: 'Spara',
  },
  passwordChanged: {
    title: 'Lösenordet harändrats',
    gotIt: 'Jag förstår',
  },
  firstLoanRegister: {
    areYouClient: 'Är du kund?',
    login: 'logga in',
    title: 'Fyll i dina uppgifter',
    requirementsTitle: 'Vilka krav ställs på mig som kredittagare?',
    requirements: [
      'Sökanden måste vara minst 18 år',
      'Inneha svenskt personnummer, mobilnummer och kontonummer ',
      'Genomgå sedvanlig kreditprövning.',
    ],
    personalDetailsTitle: 'Person- och bankuppgifter',
    incomeDetailsTitle: 'In- och utgifter',
    householdDetailsTitle: 'Hushåll',
    contactDetailsTitle: 'Kontakt information',
    createPasswordTitle: 'Skapa ett lösenord',
    submitButtonText: 'Registrera',
    securityNotice:
      'Du kan vara säker på att Vivus.se använder den senaste tekniken för att hålla dina uppgifter krypterade och skyddade.',
    additionalInfo: [
      {
        title: 'Utbetalningstid',
        text: 'Du får pengarna inom 7 – 10 dagar. Om den sjunde dagen är en helg får du pengarna nästa arbetsdag.',
      },
      {
        title: 'Är min personliga information säker?',
        text: '<a href="https://www.vivus.se/laanevilkor/behandling-av-personuppgifter">Personlig information</a>',
      },
    ],
    fields: {
      firstName: { label: 'Förnamn' },
      lastName: { label: 'Efternamn' },
      personalId: {
        label: 'Personnummer',
        helperText: 'Ange ditt personnummer (10 siffror)',
      },
      bankAccountNumber: {
        label: 'Kontonummer',
        helperText:
          'Tänk på att du vet att identifieringar via Tink måste använda en associerad bankinloggning till det angivna kontonumret.',
      },
      monthlyIncome: {
        label: 'Din månadsinkomst före skatt',
        helperText:
          'Vänligen upge din totala inkomst ink. pension, bidrag samt annan inkomst av tillgångar i kronor',
      },
      monthlyOtherLoans: {
        label: 'Ränta och amortering',
        helperText: 'på övriga lån/månad',
      },
      monthlyHousingCosts: {
        label: 'Din del av boendekostnad/månad',
        helperText:
          'Vänlige uppge din del av hushållskostnaden som el, hyra, etc',
      },
      monthlyOtherLivingCosts: {
        label: 'Övriga kostnader/månad',
        helperText: 'Vänligen uppge din del av övriga kostnader per månad',
      },
      email: {
        label: 'E-post',
        helperText: 'Vi behöver dem för att skicka meddelanden om ditt lån.',
      },
      phone: { label: 'Mobiltelefonnummer' },
      password: {
        label: 'Lösenord',
        helperText:
          'Lösenordet måste bestå av minst 8 tecken, varav minst ett ska vara ett nummer.',
      },
      agreement1: {
        text: 'Jag ansöker om länet, har tagit del av, godkänner och har lagrat de <a href="https://www.vivus.se/lanevillkor">allmänna villkoren och Standardiserad Europeisk Konsumentkreditinformation</a>. Jag försäkrar att de uppgifter som har lämnats är fullständiga och riktiga. Jag godkänner ränta och samtliga avgifter enligt punkten Prisbilaga i de allmänna villkoren. Jag samtycker till behandling av min personuppqifter enlig punkten Behandling av personuppgifter i de allmänna villkoren. Jag har läst och godkänner även behandling av mina personuppgifter enligt <a href="https://www.vivus.se/lanevillkor/integritetspolicy">integritetspolicyn</a>.',
      },
      agreement2: {
        text: 'Jag accepterar att fà nyheter och erbjudanden frän finance AB och andra bolag i företagsgruppen via telefon, email och sms. Jag kan alltid kontakta 4finance AB om jag inte vill ha denna marknadsföring i framtiden.',
      },
      numberOfChildrenInHouse: {
        label: 'Barn under 18 år i hushållet',
        // 0 - 10
        options: [
          {
            name: '...',
            value: '',
          },
          ...Array.from<number, { name: string; value: string }>(
            { length: 11 },
            (_, index) => ({
              name: index.toString(),
              value: index.toString(),
            }),
          ),
        ],
      },
      numberOfAdultsInHouse: {
        label: 'Antal vuxna i hushållet',
        // 1 - 10
        options: [
          {
            name: '...',
            value: '',
          },
          ...Array.from<number, { name: string; value: string }>(
            { length: 10 },
            (_, index) => ({
              name: (index + 1).toString(),
              value: (index + 1).toString(),
            }),
          ),
        ],
      },
    },
    validations: {
      wrongFormat: {
        personalId: 'Ange ett giltigt personnummer',
        bankAccountNumber: 'Ange ett giltigt bankkontonummer',
        email: 'Ange en giltig e-postadress',
        phone: 'Ange ett giltigt telefonnummer',
      },
      requiredField: 'Detta fält är obligatoriskt',
      wrongDomain: 'Ange en e-postadress med en giltig domän',
      agreementRequired: 'Vänligen acceptera villkoren för att fortsätta',
      tooShort: 'Lösenordet måste vara minst {passwordMinLength} tecken långt',
      numbersAndLetters:
        'Lösenordet måste innehålla både siffror och bokstäver',
      tooOld: 'Du är inte berättigad till ett lån på grund av ålder',
      tooYoung: 'Du är inte berättigad till ett lån på grund av ålder',
    },
  },
  questionnaire: {
    title: 'Vänligen besvara nedanstående frågor',
    subtitle:
      'I enlighet med lokala regulatoriska krav på finansmarknaden i Sverige ber vi dig besvara följande frågor. Så snart du besvarat frågorna kommer du att kunna fortsätta vidare.',
    selectAnswer: 'Välj',
    other: 'Annat',
    submitButtonText: 'BEKRÄFTA',
    securityNotice:
      'Du kan vara säker på att Vivus.se använder den senaste tekniken för att hålla dina uppgifter krypterade och skyddade.',
    fields: {
      PEP: { label: '' },
      JOB: { label: '' },
      PROF_FIELD: { label: '' },
      LOANS_PLANNED: { label: '' },
      MONEY_PURPOSE: { label: '' },
      BEHALF: {
        label: '',
        helperText: 'Är lånet till dig själv? Handlar du för eget bruk?',
      },
    },
    validations: {
      requiredField: 'Detta fält är obligatoriskt',
    },
  },
  approved: {
    title: 'Lånet är godkänt!',
    subtitle: `<p>Du kommer att få pengar om: <strong>{days} dagar</strong></p><p>Avtalet har skickats till din e-post.</p>`,
    subtitleTooltip:
      'Du får pengarna inom 7-10 dagar. Om den sjunde dagen är en allmän helgdag så får du pengarna nästkommande arbetsdag',
    card: {
      top: `Du kan ändra utbetalningsdatumet och få pengar på`,
      bottom: 'Avgiften för att ändra utbetalningsdatumet:',
      button: 'Få pengar på {minutes} minuter',
      tooltip:
        'Pengarna betalas ut inom 10 minuter i 98% av fallen, även om det är helgdag idag, om du har <b>Nordea, Swedbank, Handelsbanken, SEB eller Danske Bank</b>. Alla andra banker, senast nästa bankdag.',
    },
    bottomInfo:
      'Tillkommer som en engångsbetalning till fakturan på ditt förfallodatum. Genom att klicka på "Få pengar på {minutes} minuter" godkänner jag härmed avgiften för att ändra utbetalningsdatumet. Avgiften beräknas utifrån de priser som framgår i de allmänna villkoren.',
    bottomInfoTwo:
      'Om utbetalning av ditt lån är försenad i mer än 10 minuter har du rätt att begära ett avbrytande av direktutbetalningsavgiften. Läs mer',
    bottomInfoTwoLinkText: 'här',
    bottomInfoTwoLinkUrl:
      'https://www.vivus.se/ansok-om-lan/www-vivus-se-ansok-om-lan-informacion',
  },
  approvedManual: {
    title: 'Vi är nästan framme!',
    card: {
      top: 'Ha din mobiltelefon nära till hands',
      bottom:
        'Vi behandlar nu din ansökan och kan komma att kontakta dig om vi behöver ytterligare information. Annars kommer du att få ett meddelande så snart en handläggare har kontrollerat din ansökan.',
    },
  },
  rejected: {
    title: 'Lånet avslogs',
    card: {
      main: 'Din ansökan kan tyvärr inte beviljas',
      bottom:
        'För mer information om vad som krävs för att få en kredit kan du läsa under',
    },
    button: 'Tillbaka till hemsidan',
  },
  cancelled: {
    title: 'Ansökan är avbruten',
    card: {
      main: 'Din ansökan kan tyvärr inte beviljas',
      bottom:
        'För mer information om vad som krävs för att få en kredit kan du läsa under',
    },
    button: 'Tillbaka till hemsidan',
  },
  rejectedTink: {
    title: 'Avvisas på grund avatt Tink respons',
    card: {
      main: 'Tyvärr så har din ansökan blivit avbruten, det kan finnas olika anledningar till detta.',
      bottom: 'Du kan hitta mer information under',
    },
    button: 'Tillbaka till hemsidan',
  },
  fdfApplied: {
    title: 'Tack, ändringar i utbetalningsvillkoren för låneavtal gjordes.',
    card: {
      top: 'Pengarna kommer att betalas ut till ditt bankkonto inom <strong>10&nbsp;minuter!</strong> Ett nytt avtal och faktura har precis skickats till din e-post.',
      bottom: 'Ditt bankkonto där du får pengarna',
    },
  },
  loading: {
    title: 'Kontrollerar din information',
    subtitle:
      'Stäng inte fönstret ännu. Den här processen kan ta några minuter.',
  },
  identificationMethod: {
    title: 'Välj identifieringsmetod',
    bank: {
      title: 'Internetbank',
      description: 'Verifiera dig via din bank och få ett svar omgående',
      duration: '5min',
      recommended: 'Rekommenderad',
    },
    manual: {
      title: 'Manuell identifiering',
      description:
        'Vi kommer att se över din ansökan och återkomma till dig via telefon',
      duration: '1h',
    },
  },
  tink: {
    title: 'Verifiera din identitet via din internetbank',
    card: {
      warningTitle: 'Viktigt',
      warningText:
        'Verifiera din identitet via din online-tjänst Identifieringstjänsten utförs via Tink, den europeiska ledaren inom öppen bankverksamhet.',
      checkbox:
        'Jag samtycker till att information och transaktioner från mitt bankkonto samlas in och används i ansökningsprocessen för att fastställa min identitet och bedöma min kreditvärdighet. Läs mer här',
      button: 'Identifiera dig online',
      secureText: 'Snabbt och säkert',
    },
    manual: 'Om du inte har en internetbank,',
    manualLink: 'klicka här',
  },
  notFound: {
    title: 'Sidan hittades inte',
    subtitle: 'Något har gått fel. Tyvärr finns inte sidan du vill komma åt.',
    buttonText: 'Tillbaka hem',
    footer: {
      logout: 'Logga ut',
      contact,
    },
  },
  navbar: {
    amount: 'Att betala',
    duration: 'Dagar till betalning',
    repaymentDate: 'Förfallodatum',
  },
  leftPanel: {
    welcomeBackTitle: 'Hej igen!',
    welcomeBackButton: 'Ansök',
    loanSummary: 'Lånesammanfattning',
    creditAmount: 'Kreditbelopp',
    creditTooltip:
      'Utbetalning kommer att ske inom 7-10 dagar. Det finns möjlighet att ändra utbetalningsdatum mot en extra avgift enligt lånevillkoren, pengarna betalas då ut på 10 minuter.',
    daysToPayment: 'Dagar till betalning',
    daysToPaymentTooltip:
      'Förfallodagen kan ändras beroende på det faktiska utbetalningsdatumet.',
    change: 'Ändra',
    interest: 'Ränta',
    setupFee: 'Uppläggningsavgift',
    effectiveInterestRate: 'Effektiv ränta',
    toPay: 'Att betala',
    leastAmountToPay: 'Lägst att betala',
    amortization: 'Amortering',
    accountingFeeForPartialPayment: 'Bokföringsavgift för delbetalning',
    invoiceFee: 'Fakturaavgift',
    highCostCredit: 'Att låna kostar pengar!',
    highCostCreditDescription:
      'Om du inte kan betala tillbaka skulden i tid riskerar du en betalningsanmärkning. Det kan leda till svårigheter att få hyra bostad, teckna abonnemang och få nya lån. För stöd, vänd dig till budget- och skuldrådgivningen i din kommun. Kontaktuppgifter finns på <a href="https://www.konsumentverket.se/" target="_blank" rel="noreferrer">konsumentverket.se</a>.',
    creditSafeLogoAlt: 'Kreditkontroll I samarbete med creditsafe',
    representativeExample:
      'Kalkylatorn visar ett representativt exempel på ett nytt lån på 10 000 kr med en återbetalningstid på 30 dagar. Den nominella fasta årliga räntan är <b>22.0%</b>. Den effektiva räntan med en återbetalningstid på 30 dagar är <b>43.1%</b>, den inkluderar uppläggningsavgiften 118 kr. Om kunden betalar tillbaka lånet i sin helhet på förfallodagen är det totala beloppet som ska betalas <b>10,299</b> kr.',
  },
  contact,
  progress: {
    registration: 'Registrering',
    identification: 'Identifiering',
    verification: 'Svarsalternativ',
  },
  twoFA: {
    title: 'Verifiering av profil',
    desc: 'Ange den kod vi skickade till din e-postadress som du angav vid registreringen.',
    input_title: 'Ange kod',
    resend_code: 'Skicka koden igen',
    cto: 'logga in',
    footer:
      'Om du inte fick koden till den registrerade e-postadressen eller om du använder en annan e-postadress, vänligen kontakta oss på telefon <a href="tel:0842040020">08 420 400 20</a>.',
    notif:
      'Ytterligare verifiering krävs för att säkerställa Vivus.se-kundernas datasäkerhet.',
    errors: {
      GENERIC_2FA_ERROR: 'Tvåfaktorsautentisering misslyckades.',
      VERIFICATION_ID_NOT_CREATED: 'Verifikations-ID kunde inte skapas.',
      CLIENT_NOT_FOUND_BY_CLIENT_NUMBER:
        'Klient hittades inte med angivet nummer.',
      CLIENT_NUMBER_NOT_FOUND_BY_VERIFICATION_ID:
        'Ingen klient matchar verifikations-ID.',
      VERIFICATION_ID_NOT_FOUND_BY_CODE_ID_AND_CODE_INCORRECT_CODE:
        'Ogiltig eller felaktig verifikationskod.',
      NOTIFICATION_SENDER_NOT_FOUND: 'Aviseringssändare hittades inte.',
      CODE_NOT_MATCHED: 'Angiven kod matchar inte.',
      TOO_MANY_ATTEMPTS: 'För många misslyckade försök.',
      GENERIC: 'Ett oväntat fel uppstod.',
    },
  },
};

export default translations;
